import { iniciais } from "@/modules/escala/format";

interface AvatarProps {
  nome: string;
  tamanho?: "md" | "sm";
}

/**
 * Fundos sem significado de estado (nada de verde/vermelho/amarelo, que no
 * módulo Escala já querem dizer confirmada/recusada/pendente). As iniciais
 * ficam sempre em `text-text`: colorir a letra com `text-primary`/`text-info`
 * dava 3,0–4,0:1 no tema escuro.
 */
const FUNDOS = ["bg-primary/10", "bg-info/10", "bg-surface-2"] as const;

function indiceDaCor(nome: string): number {
  let soma = 0;
  for (const letra of nome) soma += letra.charCodeAt(0);
  return soma % FUNDOS.length;
}

/** Círculo com as iniciais — decorativo (o nome sempre aparece em texto ao lado). */
export function Avatar({ nome, tamanho = "md" }: AvatarProps) {
  const dimensao = tamanho === "sm" ? "h-8 w-8 text-[11px]" : "h-10 w-10 text-sm";
  return (
    <span
      aria-hidden
      className={`grid shrink-0 place-items-center rounded-full font-bold text-text ${dimensao} ${FUNDOS[indiceDaCor(nome)]}`}
    >
      {iniciais(nome)}
    </span>
  );
}
